import { render, staticRenderFns } from "./DisplayToDoTask.vue?vue&type=template&id=40d1916d"
import script from "./DisplayToDoTask.vue?vue&type=script&lang=js"
export * from "./DisplayToDoTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40d1916d')) {
      api.createRecord('40d1916d', component.options)
    } else {
      api.reload('40d1916d', component.options)
    }
    module.hot.accept("./DisplayToDoTask.vue?vue&type=template&id=40d1916d", function () {
      api.rerender('40d1916d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DisplayToDoTask.vue"
export default component.exports